export default __webpack_public_path__ + "static/media/shell.ec14d1f0.jpg";